module.exports = __webpack_public_path__ + "faf772e27b452aee46108f7726c97025.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/ic_facebook_colour.svg
// module id = bbZ0
// module chunks = 5